// Display helpers for elevation data sources returned by /api/elevation/coverage.

// Grid spacing in the user's units, e.g. "3.3 ft" or "30 m"
export function formatResolution(meters, elevationUnits) {
  if (!isNumber(meters)) return null;
  const value = meters * elevationUnits.multiplier;
  return `${numberFormatted(value, { decimals: value < 10 ? 1 : 0 })} ${elevationUnits.name}`;
}

// A plain-language rating of the source data's resolution, based on grid spacing.
// `bars` drives a signal-strength style indicator out of 3.
// @unocss-include
export function elevationDetailLevel(meters) {
  if (!isNumber(meters)) return null;
  if (meters <= 2) {
    return { label: "High-resolution data", bars: 3, barClass: "bg-green-600" };
  }
  if (meters <= 10) {
    return { label: "Medium-resolution data", bars: 2, barClass: "bg-amber-500" };
  }
  return { label: "Low-resolution data", bars: 1, barClass: "bg-orange-600" };
}

export const ELEVATION_METHODS = {
  lidar: {
    label: "Airborne lidar",
    description:
      "measured by airborne lidar, which maps the bare ground with laser pulses fired from aircraft, filtering out buildings and trees",
  },
  satellite: {
    label: "Satellite",
    description:
      "measured from orbit by satellite, which captures the top of whatever covers the ground, so buildings and forest canopy can raise the reading by several meters",
  },
};
